export default function sanitizeQuery(query) {
  const sanitized = {}
  Object.keys(query).forEach((key) => {
    if (typeof query[key] === 'string') {
      sanitized[key] = query[key]
        .replace(/<script.*?>.*?<\/script>/gi, '')
        .replace(/<.*?>/g, '')
        .trim()
    } else {
      sanitized[key] = query[key]
    }
  })
  return sanitized
}
